import React from 'react';

const Icon = ({ size = '88', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 88 88" fill="none" {...other}>
            <g clipPath="url(#a)" stroke={fill} strokeWidth="5">
                <path
                    d="M42.066 16.887c5.276 5.276 5.276 13.831 0 19.107a13.452 13.452 0 0 1-5.573 3.36V73.71H28.53V39.355a13.452 13.452 0 0 1-5.573-3.36c-5.276-5.277-5.276-13.832 0-19.108a13.452 13.452 0 0 1 5.573-3.36v12.118h7.962V13.527a13.448 13.448 0 0 1 5.573 3.36Z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />

                <path d="M54 45.667c0-.92.746-1.667 1.667-1.667h10c.92 0 1.666.746 1.666 1.667v26.666c0 .92-.746 1.667-1.666 1.667h-10c-.92 0-1.667-.746-1.667-1.667V45.667Z" />

                <path d="M56.667 26v18h8V26l2.666-4-2.666-8h-8L54 22l2.667 4Z" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M4 4h80v80H4z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
